var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-book-add"}},[_c('vx-card',{staticClass:"mb-base",attrs:{"title":"교재 상세 정보"}},[_c('book-add-form',{staticClass:"mt-4"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }